import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: 0;
`;
